import TeamSection from "./TeamSection";
import { Helmet } from "react-helmet";

export default function About(){
    return(
        <>


<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/logo.jpg",
     "image":"https://www.omsaipg.in/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email":"omsaipgpune@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG|About|Best PG Near Eon IT Park Kharadi|Hostel in Kharadi | Om Sai PG Kharadi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, PG in Kharadi, PG with food in Pune, PG for students in Kharadi, PG for females in Pune, PG for males in Pune, Om Sai PG Kharadi, Girls Hostels in Kharadi, Boys Hostel in Kharadi, Monthly Basis PG in Kharadi, PG in Wagholi, PG in Kharadi with food, Hostels in Pune, PG for Students in Kharadi Pune, Paying Guest Hostel in Chandan Nagar"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

          <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>About</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>About</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>About</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div className="section-about padding-tb-50">
      <div className="container">
        <div className="row mb-minus-24">
          <div className="col-lg-6 col-12 mb-24" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-about-img">
              <img src="img/about/about.jpg" alt="about-two" className="rx-white-img" />
            </div>
          </div>
          <div className="col-lg-6 col-12 mb-24" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            <div className="rx-about-page-contact">
              <div className="rx-banner">
                <p>About Us</p>
                <h4>Welcome to <span> Om Sai PG</span></h4>
              </div>
              <div className="inner-about-contact">
                <p>
                Welcome to Om Sai PG, your comfortable and affordable home away from home. Located in the prime area of Kharadi, near Eon IT Park, Om Sai PG offers well-equipped and secure accommodations in two separate buildings, perfect for working professionals, students, or anyone seeking a peaceful living environment.
                </p>
                <p>
                Our PG rooms come with a variety of amenities designed to make your stay convenient and hassle-free:
                </p>
                <ul className="mylist-item">
  <li> - Washing Machine for laundry needs</li>
  <li> - Wi-Fi for seamless internet connectivity</li>
  <li>- TV in each room for entertainment</li>
  <li>- 24/7 Water Supply for uninterrupted comfort</li>
  <li>- Geyser for hot water</li>
  <li>- 2-Wheeler Parking available for your convenience</li>
  <li>- Fridge for storing perishables</li>
  <li>- Gas connection for cooking</li>
  <li>- 24-Hour Hot Water supply</li>
  <li>- Free Housekeeping services</li>
  <li>- Free Electric Bills to keep your expenses low</li>
  <li>- Purified Drinking Water for your health and safety</li>
  <li>- CCTV Surveillance for your security</li>
</ul>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <TeamSection></TeamSection>

        </>
    )
}